// Angular
import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
// RxJS
import { Observable } from 'rxjs';
import { AuthService } from '../_services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard   {
  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // Usando Promesas
    console.log('Ejecutando AuthGuar');
    return this.authService.isSessionValid()
      .then(isLogged => {
          if (!isLogged) {
            this.authService.redirectUrl = state.url;
            this.router.navigate(['auth/login']);
              return false;
          } else if (state.url !== '/disclaimer' && this.authService.needsToSignDisclaimer()) {
            this.authService.redirectUrl = state.url;
            this.router.navigate(['disclaimer'])
            return false;
          }
          this.authService.tryToAuthorizeUser();
          return true;
      });
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isLoggedIn()
    .then(islogged =>{
          const permissionId = route.data.permissionId;
          if (islogged && this.authService.isAuthorized(permissionId)) {
            return true;
          }
        this.router.navigate(['error/403'], { queryParams: { returnUrl: state.url } });
        return false;
    })
  }  
}
